document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('product-search-input');
    const collectionSelect = document.getElementById('equipment-type-select');
    const table = document.getElementById('product-results-table');
    const productResult = document.getElementById('product-results');
    const productHover = document.getElementById('product-hover');
    const tbody = table.querySelector('tbody');
    const tableHead = table.querySelector('thead');
    const searchButton = document.getElementById('product-search-button');
    const errorContainer = document.getElementById('error-message');
    const tokenElement = document.getElementById('storefront-token');
    const accessToken = tokenElement.getAttribute('data-token');
    const productsPerPage = 4;
    let currentPage = 1;
    let cachedAllProducts = null;

    if (!accessToken) {
        console.error("Access token is missing.");
        showError("Unable to fetch data. Please contact support.");
        return;
    }

    const metaobjectsQuery = `
        query {
            metaobjects(type: "equipment_type_list", first: 100) {
                edges {
                    node {
                        id
                        fields {
                            key
                            value
                        }
                    }
                }
            }
        }
    `;

    async function fetchMetaobjects() {
        try {
            const response = await fetch('/api/2023-07/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': accessToken,
                },
                body: JSON.stringify({ query: metaobjectsQuery }),
            });

            const result = await response.json();
            return result.data?.metaobjects?.edges.map(edge => edge.node) || [];
        } catch (error) {
            console.error("Error fetching metaobjects:", error);
            return [];
        }
    }

    async function populateDropdown() {
        const metaobjects = await fetchMetaobjects();
        collectionSelect.innerHTML = '<option value="">Select Equipment Type</option>';

        if (!metaobjects.length) {
            collectionSelect.innerHTML = '<option value="">No Equipment Types Available</option>';
            return;
        }

        const options = metaobjects
            .map(metaobject => {
                const eqIdField = metaobject.fields.find(field => field.key === 'eq_id');
                const eqValueField = metaobject.fields.find(field => field.key === 'eq_value');
                if (eqIdField && eqValueField) {
                    return {
                        value: eqIdField.value,
                        label: eqValueField.value,
                        metaobjectId: metaobject.id
                    };
                }
                return null;
            })
            .filter(Boolean)
            .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));

        options.forEach(opt => {
            const option = document.createElement('option');
            option.value = opt.value;
            option.textContent = opt.label;
            option.dataset.metaobjectId = opt.metaobjectId;
            collectionSelect.appendChild(option);
        });
    }

    async function initializeDropdown() {
        await populateDropdown();
    }

    function showError(message) {
        errorContainer.textContent = message;
        errorContainer.style.display = 'block';
        productResult.style.display = 'block'
        productHover.style.display = 'block';
    }

   function clearError() {
    errorContainer.textContent = '';
    errorContainer.style.display = 'none';
    const productCountContainer = document.getElementById('product-count');
    productCountContainer.style.display = 'block';
    productResult.style.display = 'block'
    productHover.style.display = 'block';
}


    async function fetchProducts(query, variables) {
        const allProducts = [];
        let cursor = null;
        let hasNextPage = true;

        try {
            while (hasNextPage) {
                const response = await fetch('/api/2023-07/graphql.json', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': accessToken,
                    },
                    body: JSON.stringify({ query, variables: { ...variables, cursor } }),
                });

                const result = await response.json();
                const productsData = result.data?.products;
                if (!productsData) break;

                allProducts.push(...productsData.edges.map(edge => edge.node));
                hasNextPage = productsData.pageInfo?.hasNextPage || false;
                cursor = productsData.pageInfo?.endCursor || null;
            }

            return allProducts;
        } catch (error) {
            console.error("Error fetching products:", error);
            showError("Error fetching products. Please try again later.");
            return allProducts;
        }
    }

    async function fetchSuggestHandles(term) {
        try {
            const params = new URLSearchParams({
                q: term,
                'resources[type]': 'product',
                'resources[limit]': '10',
            });
            const response = await fetch(`/search/suggest.json?${params.toString()}`, {
                headers: { 'Accept': 'application/json' },
            });
            const data = await response.json();
            return (data?.resources?.results?.products || []).map(product => product.handle);
        } catch (error) {
            console.error("Error fetching search suggestions:", error);
            return null;
        }
    }

    function debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    function displayProducts(products) {
        clearError();
        tbody.innerHTML = '';
        if (!products.length ) {
        table.style.display = 'none';
        showError("No products found for the selected equipment type and search term.");
        const productCountContainer = document.getElementById('product-count');
        productCountContainer.style.display = 'none';
        productResult.style.display = 'block';
        productHover.style.display = 'block';
        return; 
    }
    const productCount = products.length;
    const productCountContainer = document.getElementById('product-count');
    productCountContainer.innerHTML = `<a href="#" id="product-count-link">${productCount} Equipment${productCount !== 1 ? 's' : ''}</a>`;

  
    const productCountLink = document.getElementById('product-count-link');
    productCountLink.addEventListener('click', function (e) {
        e.preventDefault();
        handleSearch(true); 
    });
        const startIndex = (currentPage - 1) * productsPerPage;
        const endIndex = startIndex + productsPerPage;
        const paginatedProducts = products.slice(startIndex, endIndex);

        paginatedProducts.forEach(product => {
            const { title, handle, description, featuredImage, product_condition ,vendor} = product;
            const imageUrl = featuredImage?.url || 'https://via.placeholder.com/75';
            const Condition = product_condition?.[0]?.value;
            
            let conditionHTML = "";
            if (Condition === "Used") {
                conditionHTML = `<span class="used-label custom-label">USED</span>`;
            }
            if (Condition === "New") {
                conditionHTML = `<span class="new-label custom-label">NEW</span>`;
            }
            const truncatedDescription = description
            ? description.length > 200
                ? `${description.substring(0, 200)}...`
                : description
            : '';
            const row = document.createElement('tr');
           row.innerHTML = `
    <td><a href="/products/${handle}"><img src="${imageUrl}" alt="${title}" width="75"></a></td>
    <td>
    <div class="product-title">
        <a href="/products/${handle}" class="link">${title}</a>
         <span>${conditionHTML}</span>
        
         </div>
          <div class="brand-text">${vendor}</div>
        <div class="desc">${truncatedDescription}</div>
       
    </td>
`;
            tbody.appendChild(row);
        });
        table.style.display = 'table';
       addPaginationControls(products);
    }
  function addPaginationControls(products) {
        const totalPages = Math.ceil(products.length / productsPerPage);
        const paginationContainer = document.getElementById('pagination-controls');
        paginationContainer.innerHTML = '';

        if (totalPages > 1) {
            const prevButton = document.createElement('button');
            prevButton.textContent = 'Previous';
            prevButton.classList.add('prev');
            prevButton.disabled = currentPage === 1;
            prevButton.addEventListener('click', () => {
                currentPage = Math.max(1, currentPage - 1);
                handleSearch(false);
            });

            const nextButton = document.createElement('button');
            nextButton.textContent = 'Next';
            nextButton.classList.add('next');
            nextButton.disabled = currentPage === totalPages;
            nextButton.addEventListener('click', () => {
                currentPage = Math.min(totalPages, currentPage + 1);
                handleSearch(false);
            });

            paginationContainer.appendChild(prevButton);
            paginationContainer.appendChild(nextButton);
        }
    }
    let selectedMetaobjectId = null;

    async function handleSearch(isRedirect = false) {
    const searchValue = searchInput.value.trim();
    const selectedOption = collectionSelect.options[collectionSelect.selectedIndex];
    const selectedMetaobjectId = selectedOption?.dataset?.metaobjectId || null;
    const loader = document.getElementById('loader');
    const productCountContainer = document.getElementById('product-count');

    loader.style.display = 'none';
    productCountContainer.style.display = 'none';
    productHover.style.display = 'block';
    tbody.innerHTML = '';
    table.style.display = 'none';
    tableHead.style.display = 'none';
    productResult.style.display = 'block';

    if (!selectedMetaobjectId && !searchValue) {
        showError("Please select an equipment type or enter a search term.");
        return;
    }

    if (searchValue && searchValue.length < 3) {
        showError("Search term must be at least 3 characters.");
        return;
    }

    loader.style.display = 'block';
    
    const productQuery = `
    query ($search: String, $cursor: String) {
        products(first: 250, query: $search, after: $cursor) {
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    id
                    title
                    handle
                    description
                    vendor
                    featuredImage {
                        url
                    }
                    metafields(identifiers: [{namespace: "custom", key: "equipment_type"}]) {
                        namespace
                        key
                        value
                    }
                    product_condition: metafields(identifiers: [{namespace: "custom", key: "product_condition"}]) {
                        namespace
                        key
                        value
                    }
                    year: metafields(identifiers: [{namespace: "custom", key: "year"}]) {
                        key
                        value
                    }
                    make: metafields(identifiers: [{namespace: "custom", key: "make"}]) {
                        key
                        value
                    }
                    model: metafields(identifiers: [{namespace: "custom", key: "model"}]) {
                        key
                        value
                    }
                    serial_number: metafields(identifiers: [{namespace: "custom", key: "serial_number"}]) {
                        key
                        value
                    }
                }
            }
        }
    }`;
    
    const variables = { search: searchValue };
    if (searchValue && searchValue.length < 3) {
        showError("Search term must be at least 3 characters or more.");
        const productCountContainer = document.getElementById('product-count');
        productCountContainer.style.display = 'none';
        table.style.display = 'none';
        productResult.style.display = 'block';
        productHover.style.display = 'block';
    } else {
    try {
        const normalizeString = (str) => {
            return str.toLowerCase().replace(/[-/]/g, '');
        };

        const getAllProducts = async () => {
            if (!cachedAllProducts) {
                cachedAllProducts = await fetchProducts(productQuery, { search: null });
            }
            return cachedAllProducts;
        };

        const applyEquipmentFilter = (list) => {
            if (!selectedMetaobjectId) return list;
            return list.filter(product => {
                const metafield = (product.metafields || []).find(field => field && field.key === "equipment_type");
                return metafield && metafield.value === selectedMetaobjectId;
            });
        };

        const applySearchFilter = (list) => {
            if (!searchValue) return list;
            const normalizedSearch = normalizeString(searchValue);
            return list.filter(product => {
                const haystack = normalizeString([
                    product.title,
                    product.year?.[0]?.value,
                    product.make?.[0]?.value,
                    product.model?.[0]?.value,
                    product.serial_number?.[0]?.value,
                ].filter(Boolean).join(' '));
                return haystack.includes(normalizedSearch);
            });
        };

        const products = await fetchProducts(productQuery, variables);

        let filteredProducts;

        if (searchValue) {
            let localMatches = applySearchFilter(products);
            if (!localMatches.length) {
                localMatches = applySearchFilter(await getAllProducts());
            }

            let suggestMatches = [];
            const suggestHandles = await fetchSuggestHandles(searchValue);
            if (suggestHandles && suggestHandles.length) {
                const byHandle = new Map(products.map(product => [product.handle, product]));
                if (suggestHandles.some(handle => !byHandle.has(handle))) {
                    (await getAllProducts()).forEach(product => {
                        if (!byHandle.has(product.handle)) byHandle.set(product.handle, product);
                    });
                }
                suggestMatches = suggestHandles.map(handle => byHandle.get(handle)).filter(Boolean);
            }

            const seen = new Set(suggestMatches.map(product => product.id));
            filteredProducts = [
                ...suggestMatches,
                ...localMatches.filter(product => !seen.has(product.id)),
            ];

            filteredProducts = applyEquipmentFilter(filteredProducts);
        } else {
            filteredProducts = applyEquipmentFilter(products);
        }

        if (!filteredProducts.length) {
            showError("No products found for the selected equipment type and search term.");
            const productCountContainer = document.getElementById('product-count');
            productCountContainer.style.display = 'none';
            table.style.display = 'none';
            productResult.style.display = 'block';
            productHover.style.display = 'block';
        } else {
            displayProducts(filteredProducts);
        }

        if (isRedirect == true) {
            let filterUrl = '/search?';
            const equipmentTypeLabel = selectedOption ? selectedOption.textContent.trim() : '';

            if (searchValue) {
                filterUrl += `q=${encodeURIComponent(searchValue)}&`;
            } else if (equipmentTypeLabel) {
                filterUrl += `q=${encodeURIComponent(equipmentTypeLabel)}&`;
            }

            if (selectedMetaobjectId) {
                filterUrl += `filter.p.m.custom.equipment_type=${encodeURIComponent(selectedMetaobjectId)}&`;
            }

            filterUrl = filterUrl.endsWith('&') ? filterUrl.slice(0, -1) : filterUrl;
            window.location.href = filterUrl;
        }
    } catch (error) {
        console.error("Search error:", error);
        showError("An error occurred while searching. Please try again later.");
    } finally {
        loader.style.display = 'none';
    }
}
    }
    collectionSelect.addEventListener('change', function () {
        const selectedOption = collectionSelect.options[collectionSelect.selectedIndex];
        selectedMetaobjectId = selectedOption?.dataset?.metaobjectId || null; 
        handleSearch(false); 
    });
    searchInput.addEventListener('keyup', debounce(handleSearch, 300));
    searchButton.addEventListener('click', () => handleSearch(true));
    initializeDropdown();
});